import { useAuiState } from "@assistant-ui/react";
import { HandMark } from "@/features/copilot/components/hand-mark";
import { isCopilotThinkingVisible } from "@/features/copilot/lib/copilot-thinking";

/// `serverRunning` covers a reload mid-turn, when the server is still working but this tab's
/// runtime never started the run.
export function CopilotThinkingIndicator({ serverRunning }: { serverRunning: boolean }) {
  const runtimeRunning = useAuiState((state) => state.thread.isRunning);
  const latest = useAuiState((state) => state.thread.messages.at(-1));
  if (!isCopilotThinkingVisible(runtimeRunning || serverRunning, latest)) return null;

  return (
    <div className="flex h-7 items-center">
      <span className="sr-only">Hand is thinking</span>
      <HandMark animated className="size-7 text-primary dark:text-(--pw-violet-300)" />
    </div>
  );
}
